import React from 'react';
import './Footer.scss';

const Footer = () => (
  <footer className="Footer">
    <small className="Attribution">
      Logo made by <a href="https://www.flaticon.com/authors/vectors-market" className="Attribution__link" title="Vectors Market">Vectors Market</a> from <a href="https://www.flaticon.com/" className="Attribution__link" title="Flaticon"> www.flaticon.com</a>
    </small>
    <small className="Attribution">
      Made with love by <a href="https://www.jamesspence.dev/" target="_blank" className="Attribution__link">James Spence</a>
    </small>
  </footer>
);

export default Footer;